import React, { useState } from "react";
import { applyPhotoExtras } from "../../../Common/photoCredit";
import "./PlaceCard.css";
import PlaceModal from "../../modals/PlaceModal";
import Common, { isSearchResult } from "../../../Common/Common";
import { urlSchemeToFunctions } from "../../../CommonWeb/Common";
import PlaceMenu from "../../../CommonWeb/PlaceMenu";
import { useSelector } from "react-redux";
import Place from "../../../Models/Place";
import { useDispatch } from "react-redux";
import { slice1Actions } from "../../../store/reducer";
import PlaceEditModal from "../../modals/PlaceEditModal";
import ImageDialog from "../../modals/ImageDialog";
import HTMLReader from "../../modals/HTMLReader";
import GooglePlaces from "../../../Models/GooglePlaces";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

const PlaceCard = (props) => {
  const [placeModal, setPlaceModal] = useState(false);
  const [PlaceEditModalShow, setPlaceEditModalShow] = useState(false);
  const [ImageDialogShow, setImageDialogShow] = useState(false);
  const [AttributesReaderShow, setAttributesReaderShow] = useState(false);
  const [AttributesReaderHtml, setAttributesReaderHtml] = useState("");
  const [AttributesReaderTitle, setAttributesReaderTitle] = useState("Place Details");
  const [AttributesReaderPlaceId, setAttributesReaderPlaceId] = useState(null);
  let user_info = useSelector((state) => state.user_info);
  const dispatch = useDispatch();
  let MobileMode = useSelector((state) => state.MobileMode);
  let GuideEditMode = useSelector((state) => state.GuideEditMode);
  let GuideSettings = useSelector((state) => state.GuideSettings);
  let SearchResultsPlacesList = useSelector((state) => state.SearchResultsPlacesList);

  const getImageURLString = (place) => {
    if (place == null) return "";
    // An 80 px card: the thumbnail (Photo), the main photo only when there is none (2026-11-04).
    let str = place.Photo;
    if (str === "" || typeof str === "undefined") str = place.Photo_m;
    let img = Common.getImageURL(str, Common.getFBPath(window.guide_obj.guide_id, user_info), false);
    //if (!img.startsWith("data")) console.log(img);
    return img;
  };

  const formatDistance = (distance) => {
    if (distance == null || isNaN(distance)) return "—";
    let measure = "Km";
    if (props.user_info.distance_unit == "miles") {
      distance = distance * 0.62137119;
      measure = "miles";
    }
    return `${parseFloat(distance).toFixed(3)} ${measure}`;
  };

  function handleCenterInMap(e) {
    e.stopPropagation();
    const place = window.guide_obj.places.getPlace(props.i, SearchResultsPlacesList);
    if (place == null) return;
    dispatch(slice1Actions.setMapCenterPlace({ place: place }));
    if (MobileMode) {
      dispatch(slice1Actions.setCurrentAppScreen({ value: "Map" }));
    } else {
      dispatch(slice1Actions.centerMapToPlaces({ value: [place] }));
      window.location.href = "#map-start";
    }
  }

  function handleShowPlaceAttributes(e) {
    e.stopPropagation();
    let htmlString = PlaceMenu.handleShowPlaceAttributes(props.i, SearchResultsPlacesList);
    htmlString = urlSchemeToFunctions(htmlString);
    // EXPERIMENT, 2026-10-05: desktop-only alternate path — push onto the
    // Home tab's own HTMLStack instead of the local dialog. setHTMLToSHow
    // already appends to HTMLStack (not an overwrite-with-no-history), so
    // HomeHeader.js's existing back-arrow (shown whenever HTMLStack.length >
    // 1) works for free — this is the same mechanism Home.js's itinerarylink
    // case already relies on (see its "reused this already-working pattern"
    // comment, 2026-09-09). Mobile is untouched: single-screen nav has
    // nowhere for a desktop-style back arrow to live, so it keeps the local
    // dialog from the 2026-10-05 fix above.
    if (!MobileMode) {
      dispatch(slice1Actions.setHTMLTitle({ value: "Place Details" }));
      dispatch(slice1Actions.setHTMLToSHow({ value: htmlString }));
      window.location.href = "#home-start";
      const homeDiv = document.getElementById("home-content-start");
      if (homeDiv) homeDiv.scrollIntoView();
      return;
    }
    // Explicit, not relying on the useState default — without this, a prior
    // "Place Notes" tap left the title stale on a later "Place Details" tap.
    // Also lets onPlaceMenuLink below tell which content is showing, since
    // placemenulink: isn't exclusive to Place Details (a user can hand-
    // insert it into any HTML content via the editor's link tool). Found
    // 2026-10-06.
    setAttributesReaderTitle("Place Details");
    setAttributesReaderHtml(htmlString);
    setAttributesReaderPlaceId(props.i);
    setAttributesReaderShow(true);
  }

  // Mirrors PlaceModal.js's goToPlace — Next/Previous through props.placesList
  // (an ordered array of place IDs matching the currently-displayed Places
  // order), same feature ported from the native mobile app's HTMLViewer.
  const goToPlace = (offset) => {
    const list = props.placesList;
    if (list == null || list.length <= 1 || AttributesReaderPlaceId == null) return;
    const index = list.indexOf(AttributesReaderPlaceId);
    if (index === -1) return;
    const nextIndex = index + offset;
    if (nextIndex < 0 || nextIndex >= list.length) return;
    const nextId = list[nextIndex];
    let htmlString = PlaceMenu.handleShowPlaceAttributes(nextId, SearchResultsPlacesList);
    htmlString = urlSchemeToFunctions(htmlString);
    setAttributesReaderHtml(htmlString);
    setAttributesReaderPlaceId(nextId);
  };

  function handleEditPlace(e) {
    e.stopPropagation();
    setPlaceEditModalShow(true);
    //props.onHide();
  }

  function handleShowPlaceMenu(e) {
    e.stopPropagation();
    setPlaceModal(true);
  }

  const PlaceEditCallback = () => {
    dispatch(slice1Actions.resetHomeScreen({ value: null }));
    dispatch(slice1Actions.setGuide({ guide: null }));
  };

  const placeSelected = (event) => {
    if (event.target.closest && event.target.closest("button")) return;
    if (event.detail === 2) {
      setPlaceModal(true);
      return;
    }
    // Part of simplifying the app, 2026-10-05: "Default" now shows Place
    // Details directly instead of the long action menu — the full menu is
    // still one double-click away, or reachable via Guide Settings' "Custom"
    // Interaction Behavior + "Display Menu" toggle. Reuses the exact same
    // handler as the card's own "i" icon, already confirmed working.
    if (GuideSettings.click_behavior !== "custom") {
      handleShowPlaceAttributes(event);
      return;
    }
    if (GuideSettings.click_behavior === "custom") {
      const place = window.guide_obj.places.getPlace(props.i, SearchResultsPlacesList);
      if (GuideSettings.places_list.path_link) {
        window.handleMarkerPathLink(place);
        return;
      }
      if (GuideSettings.places_list.menu === true) setPlaceModal(true);
      else if (
        (GuideSettings.places_list.info === true && place.Info !== "" && !place.Info.endsWith("</style>")) ||
        (GuideSettings.places_list.info === true && GuideSettings.places_list.attributes !== true)
      ) {
        if (place !== null) {
          let htmlString = place.Info;
          if (typeof htmlString === "undefined") htmlString = "";
          htmlString = urlSchemeToFunctions(htmlString);
          // EXPERIMENT, 2026-10-05: desktop pushes onto the Home tab's
          // HTMLStack instead — see handleShowPlaceAttributes above for the
          // full reasoning. Mobile keeps the local dialog, fixed 2026-08-29.
          if (!MobileMode) {
            dispatch(slice1Actions.setHTMLTitle({ value: "Place Notes" }));
            dispatch(slice1Actions.setHTMLToSHow({ value: htmlString }));
            window.location.href = "#home-start";
            const homeDiv = document.getElementById("home-content-start");
            if (homeDiv) homeDiv.scrollIntoView();
            return;
          }
          setAttributesReaderTitle("Place Notes");
          // Reset — otherwise a stale ID from a previous Place Details view
          // would wrongly show paging controls on this Place Notes view too
          // (showPaging only checks PlaceId != null, not the title). Found
          // 2026-10-06.
          setAttributesReaderPlaceId(null);
          setAttributesReaderHtml(htmlString);
          setAttributesReaderShow(true);
          return;
        }
      } else if (
        GuideSettings.places_list.info === true &&
        place.Info === "" &&
        !place.Info.endsWith("</style>") &&
        GuideSettings.places_list.attributes === true
      ) {
        let htmlString = PlaceMenu.handleShowPlaceAttributes(props.i, SearchResultsPlacesList);
        htmlString = urlSchemeToFunctions(htmlString);
        // EXPERIMENT, 2026-10-05: desktop pushes onto the Home tab's
        // HTMLStack instead — see handleShowPlaceAttributes above for the
        // full reasoning. Mobile keeps the local dialog, fixed 2026-08-29.
        if (!MobileMode) {
          dispatch(slice1Actions.setHTMLTitle({ value: "Place Details" }));
          dispatch(slice1Actions.setHTMLToSHow({ value: htmlString }));
          window.location.href = "#home-start";
          const homeDiv = document.getElementById("home-content-start");
          if (homeDiv) homeDiv.scrollIntoView();
          return;
        }
        setAttributesReaderTitle("Place Details");
        // Was missing — paging stayed broken/stale for this entry point even
        // though the title correctly said "Place Details". Found 2026-10-06.
        setAttributesReaderPlaceId(props.i);
        setAttributesReaderHtml(htmlString);
        setAttributesReaderShow(true);
      } else if (GuideSettings.places_list.attributes === true) {
        let htmlString = PlaceMenu.handleShowPlaceAttributes(props.i, SearchResultsPlacesList);
        htmlString = urlSchemeToFunctions(htmlString);
        // EXPERIMENT, 2026-10-05: desktop pushes onto the Home tab's
        // HTMLStack instead — see handleShowPlaceAttributes above for the
        // full reasoning. Mobile keeps the local dialog, fixed 2026-08-29.
        if (!MobileMode) {
          dispatch(slice1Actions.setHTMLTitle({ value: "Place Details" }));
          dispatch(slice1Actions.setHTMLToSHow({ value: htmlString }));
          window.location.href = "#home-start";
          const homeDiv = document.getElementById("home-content-start");
          if (homeDiv) homeDiv.scrollIntoView();
          return;
        }
        setAttributesReaderTitle("Place Details");
        // Same fix as above.
        setAttributesReaderPlaceId(props.i);
        setAttributesReaderHtml(htmlString);
        setAttributesReaderShow(true);
      } else if (GuideSettings.places_list.center === true) {
        const place = window.guide_obj.places.getPlace(props.i, SearchResultsPlacesList);
        if (place == null) return;
        dispatch(slice1Actions.centerMapToPlaces({ value: [place] }));
        // if (MobileMode) dispatch(slice1Actions.setCurrentAppScreen({ value: "Map" }));
        // else window.location.href = "#map-start";
      } else if (GuideSettings.places_list.filter === true) {
        if (place !== null) {
          dispatch(slice1Actions.ClearAllFilters({ value: null }));
          dispatch(slice1Actions.SetPlacesFilter({ value: [place] }));
          dispatch(slice1Actions.setGuide({ guide: null }));
        }
      } else if (GuideSettings.places_list.url === true) {
        PlaceMenu.handleShowPlaceUrl(props.i);
      }
      return;
    }
  };

  function showPlaceLink() {
    const place = window.guide_obj.places.getPlace(props.i, SearchResultsPlacesList);
    if (place == null) return "";
    window.handleMarkerPathLink(place);
  }

  const handleShowPlaceUrl = (id) => {
    const place = window.guide_obj.places.getPlace(id, SearchResultsPlacesList);
    if (place == null) return "";
    let link = place.getFirstHLink();
    if (link.includes("place_id=")) {
      const parts = link.split("=");
      console.log("parts", parts);
      GooglePlaces.getMoreDetails(getMoreDetailsCallback, parts[1]);
      return;
    }
    if (link !== "") {
      window.open(link, "_blank");
    }
  };

  const getMoreDetailsCallback = (place_id, details) => {
    if (details === null) return;
    let hlink = "";
    console.log("getMoreDetailsCallback", details);
    if (typeof details.url != "undefined") {
      if (details.url.includes(";")) {
        const urls = details.url.split(";");
        hlink = `${urls[0]}`;
      } else hlink = `${details.url}`;
    }
    console.log("getMoreDetailsCallback", hlink);
    if (hlink !== "") {
      let win = window.open(hlink, "_blank");
      if (win) win.focus();
      return null;
    }
  };

  const updateImageCallBack = (imageInfo) => {
    let new_place = new Place(window.guide_obj.places);
    new_place.Photo = imageInfo[0].url;
    new_place.Photo_m = imageInfo[0].url_m;
    // Print size and credit of a stock photo (Common/photoCredit.js).
    applyPhotoExtras(new_place, imageInfo[0]);
    window.guide_obj.places.updatePhoto(new_place, props.i);
  };

  const updateImage = (e) => {
    e.stopPropagation();
    setImageDialogShow(true);
  };

  const handleAddToGuide = (e) => {
    e.stopPropagation();
    dispatch(slice1Actions.addResultToGuide({ value: props.i }));
    dispatch(slice1Actions.setGuide({ guide: null }));
    // Adding this place re-sorts the places list, which can swap the DOM node
    // out from under the cursor. Browsers respond by synthesizing a "ghost"
    // mouseenter on whatever card ends up there, which can land on a "Center
    // on map" button and trigger its hover-preview navigation to Home. Briefly
    // disabling pointer events on the list blocks that ghost hover until the
    // re-render/reflow has settled.
    const container = document.getElementById("PlacesDiv");
    if (container) {
      container.style.pointerEvents = "none";
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          container.style.pointerEvents = "";
        });
      });
    }
  };

  return (
    <>
      <div id={props.id} className="pc-card" onClick={(e) => placeSelected(e)}>
        {/* Name across the whole card, above the photo (2026-10-17, matches
            mobile) — beside the photo long names were cut off. */}
        <div className="pc-title-row">
          <p className={`pc-name${isSearchResult(props.place.Source) ? " search-result" : ""}`} title={props.name}>
            {props.name}
          </p>
        </div>
        <div className="pc-card-row">
        <div className="pc-image-column">
          <div className="pc-image-well" onClick={updateImage}>
            <img
              src={getImageURLString(props.place)}
              alt=""
              loading="lazy"
              referrerPolicy="no-referrer"
              onError={(e) => {
                const photo = props.place.Photo;
                const photoUrl = Common.getImageURL(photo, Common.getFBPath(window.guide_obj.guide_id, user_info), false);
                if (photo && e.target.src !== photoUrl) {
                  e.target.src = photoUrl;
                } else {
                  e.target.onerror = null;
                  e.target.src = "https://andiamotravelapp.com/Images/App/IllustratedImage.jpg";
                }
              }}
            />
          </div>
          <div className="pc-badge-row">
            {props.place.PType === "Icon" && <FontAwesomeIcon title="Location" icon={solid("map-marker-alt")} className="pc-badge type-icon" />}
            {props.place.PType === "PolyLine" && <FontAwesomeIcon title="Path" icon={solid("long-arrow-alt-up")} className="pc-badge type-icon" />}
            {props.place.PType === "Polygon" && <FontAwesomeIcon title="Area" icon={solid("border-all")} className="pc-badge type-icon" />}
            {props.place.MustSee === true && <FontAwesomeIcon title="Must See" icon={solid("star")} className="pc-badge star" />}
            {props.place.BucketList === true && <FontAwesomeIcon title="Bucket List" icon={solid("bookmark")} className="pc-badge bookmark" />}
            {props.place.Favorite === true && <FontAwesomeIcon title="Favorite" icon={solid("heart")} className="pc-badge heart" />}
            {props.place.Visited === true && <FontAwesomeIcon title="Visited" icon={solid("check")} className="pc-badge check" />}
            {props.place.scheduledDates.length > 0 && <FontAwesomeIcon title="Scheduled" icon={solid("calendar")} className="pc-badge calendar" />}
            {GooglePlaces.hasImpracticalHours(props.place) && (
              <FontAwesomeIcon title="Limited hours — open few days or only briefly" icon={solid("clock")} className="pc-badge limited-hours" />
            )}
          </div>
        </div>
        <div className="pc-body">

          {props.category ? (
            <div className="pc-meta-row">
              <p className="pc-meta-label">Category</p>
              <p className="pc-meta-value">{props.category}</p>
            </div>
          ) : null}
          {props.groups ? (
            <div className="pc-meta-row">
              <p className="pc-meta-label">Groups</p>
              <p className="pc-meta-value">{props.groups}</p>
            </div>
          ) : null}
          <div className="pc-meta-row">
            <p className="pc-meta-label">Rating</p>
            <p className="pc-meta-value">{props.rating === "" ? "N/A" : props.rating}</p>
          </div>
          <div className="pc-meta-row">
            <p className="pc-meta-label">Distance</p>
            <p className="pc-meta-value">{formatDistance(props.distance)}</p>
          </div>

          <div className="pc-footer-row">
            {isSearchResult(props.place.Source) ? (
              <button className="pc-icon-btn pc-add-btn" title="Add to guide" onClick={handleAddToGuide}>
                <FontAwesomeIcon icon={solid("plus")} />
              </button>
            ) : null}
            {/* mouse_enter/mouse_leave dropped 2026-09-07 — hovering this
                icon used to highlight the matching event, scroll it into
                view, and open Place Details (in mobile mode, by navigating
                away to the Home screen entirely — never undone on mouse-
                leave, so an accidental hover permanently stranded the user
                off Places). Too disruptive for an unintentional hover, and
                "Show Attributes" right next to it already opens Place
                Details in a local modal on click. This button is back to
                doing just what it says: center on map. */}
            <button className="pc-icon-btn" title="Center on map" onClick={handleCenterInMap}>
              <FontAwesomeIcon icon={solid("crosshairs")} />
            </button>
            <button className="pc-icon-btn" title="Show Attributes" onClick={handleShowPlaceAttributes}>
              <FontAwesomeIcon icon={solid("info")} />
            </button>
            {GuideEditMode && !isSearchResult(props.place.Source) ? (
              <button className="pc-icon-btn" title="Edit Place" onClick={handleEditPlace}>
                <FontAwesomeIcon icon={solid("pencil")} />
              </button>
            ) : null}
            {props.place.Link.type !== "none" && !isSearchResult(props.place.Source) ? (
              <button className="pc-icon-btn" title="Place link" onClick={showPlaceLink}>
                <FontAwesomeIcon icon={solid("external-link-alt")} />
              </button>
            ) : null}
            <button className="pc-menu-btn" title="Menu" onClick={(e) => handleShowPlaceMenu(e)}>
              <FontAwesomeIcon icon={solid("ellipsis")} />
            </button>
          </div>
        </div>
        </div>
      </div>
      {placeModal ? (
        <PlaceModal
          show={placeModal}
          onHide={() => setPlaceModal(false)}
          name={props.name}
          img={props.img}
          i={props.i}
          mainIndex={props.mainIndex}
          id={props.id}
          groups={window.guide_obj == null ? "" : window.guide_obj.groupNamesFromIDs(props.place.Group)}
          category={window.guide_obj == null ? "" : window.guide_obj.categoryNamesFromIDs(props.place.Category)}
          //img={getImageURLString(props.place)}
          place={props.place}
          user_info={props.user_info}
          placesList={props.placesList}
        />
      ) : null}
      {PlaceEditModalShow ? (
        <PlaceEditModal
          show={PlaceEditModalShow}
          onHide={() => setPlaceEditModalShow(false)}
          img={props.img}
          name={props.name}
          index={props.i}
          mainIndex={props.mainIndex}
          id={props.id}
          place={props.place}
          groups={window.guide_obj == null ? "" : window.guide_obj.groupNamesFromIDs(props.place.Group)}
          category={window.guide_obj == null ? "" : window.guide_obj.categoryNamesFromIDs(props.place.Category)}
          user_info={user_info}
          mode={"Edit"}
          update_display={PlaceEditCallback}
          onHidePrevious={props.onHide}
          map_bounds={props.map_bounds}
          folder={props.folder}
          setImageFolder={props.setImageFolder}
        />
      ) : null}
      {ImageDialogShow ? (
        <ImageDialog
          // ImageDialog snapshots photo/photo_m into several independent
          // pieces of its own state, only in its constructor (urlText/
          // urlTextMedium, and separately URLEntered/URLEnteredMedium) — if
          // the underlying photo changes while this dialog is open (e.g.
          // "Auto Update Photo" run from the card's menu without closing
          // this one), those snapshots go stale and it keeps showing the
          // old photo. Forcing a remount whenever the photo actually
          // changes resets all of them at once, rather than patching each
          // one individually.
          key={`${props.place.Photo_m || ""}|${props.place.Photo || ""}`}
          show={ImageDialogShow}
          onHide={() => setImageDialogShow(false)}
          user_info={user_info}
          mode={"select"}
          modify_only={"true"}
          updateImage={updateImageCallBack}
          size={"sm"}
          photo={props.place.Photo}
          photo_m={props.place.Photo_m}
          multi={false}
          exif={false}
          map_bounds={props.map_bounds}
          place={props.place}
        />
      ) : null}
      <HTMLReader
        html={AttributesReaderHtml}
        show={AttributesReaderShow}
        title={AttributesReaderTitle}
        onHide={() => setAttributesReaderShow(false)}
        // placemenulink: isn't exclusive to Place Details — a user can
        // hand-insert it into Place Notes/any other HTML content too via
        // the editor's link tool, and this same local dialog shows all of
        // those. Only close it when it's actually showing Place Details;
        // otherwise leave it open underneath the menu. Found 2026-10-06.
        onPlaceMenuLink={() => {
          if (AttributesReaderTitle === "Place Details") setAttributesReaderShow(false);
          setPlaceModal(true);
        }}
        showPaging={AttributesReaderPlaceId != null && props.placesList != null && props.placesList.length > 1}
        canGoPrevious={AttributesReaderPlaceId != null && props.placesList != null && props.placesList.indexOf(AttributesReaderPlaceId) > 0}
        canGoNext={
          AttributesReaderPlaceId != null &&
          props.placesList != null &&
          props.placesList.indexOf(AttributesReaderPlaceId) !== -1 &&
          props.placesList.indexOf(AttributesReaderPlaceId) < props.placesList.length - 1
        }
        onPrevious={() => goToPlace(-1)}
        onNext={() => goToPlace(1)}
      />
    </>
  );
};

export default PlaceCard;
